import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { ButtonState } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import CustomerApi from '../api/customer/CustomerApi';
import { ChangePassword } from '../components/account/change-password/ChangePassword';
import { DELAY } from '../constants/GeneralConstants';
import { HTTPStatusCode } from '@as-react/common-types';
const ChangePasswordContainer = ({ title }) => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const [errorFeedback, setErrorFeedback] = useState();
    const [buttonState, setButtonState] = useState(ButtonState.INTERACTIVE);
    const onSubmit = (values_1, _a) => __awaiter(void 0, [values_1, _a], void 0, function* (values, { resetForm, setFieldError }) {
        var _b;
        try {
            yield CustomerApi.updatePassword(servicesEndpoint, defaultRequestParams, {
                oldPassword: values.oldPassword,
                newPassword: values.newPassword,
            });
            setButtonState(ButtonState.FINISHED);
            setErrorFeedback(null);
            resetForm();
            setTimeout(() => setButtonState(ButtonState.INTERACTIVE), DELAY.DELAY_3000);
        }
        catch (e) {
            if (((_b = e.response) === null || _b === void 0 ? void 0 : _b.status) === HTTPStatusCode.Unauthorized) {
                setFieldError('oldPassword', t('account.password.current.invalid'));
            }
            else {
                setErrorFeedback(t('account.fail'));
            }
        }
    });
    return _jsx(ChangePassword, { onSubmit: onSubmit, errorFeedback: errorFeedback, buttonState: buttonState, title: title });
};
export default ChangePasswordContainer;
